import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isEmpty, size } from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import { Button, Card, CardBody, Badge,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Col

} from "reactstrap";

import {
  getOrders,
  addNewOrder,
  updateOrder,
  deleteOrder,
} from "store/actions";

import EcommerceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal";
import { url } from "APIs/URLS";

class LatestTranaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewmodal: false,
      modal: false,
      reportmodal: false,
      id:"",
      orders: [],
      EcommerceOrderColumns: [
        {
          text: "id",
          dataField: "id",
          sort: true,
          hidden: true,
          formatter: (cellContent, user) => <>{order.id}</>,
        },
        {
          dataField: "Lab_id",
          text: "Lab ID",
          sort: true,
          formatter: (cellContent, row) => (
            <Link to="#" className="text-body fw-bold">
              {row.Lab_id}
            </Link>
          ),
        },
        {
          dataField: "PaymentType",
          text: "Payment Method",
          sort: true,
        },
        // {
        //   dataField: "orderdate",
        //   text: "Month",
        //   sort: true,
        // },
        {
          dataField: "Total",
          text: "Total",
          sort: true,
        },
        {
          dataField: "Status",
          text: "Payment Status",
          sort: true,
          formatter: (cellContent, row) => (
            <Badge
              className={"font-size-12 badge-soft-secondary" }
              
              pill
            >
              {row.Status}
            </Badge>
          ),
        },
        
        {
          dataField: "view",
          isDummyField: true,
          text: "Update Status",
          sort: true,
          formatter: (cellContent,row) => (
            <Button className="btn btn-success btn-sm btn-rounded"
            
            onClick={()=>{
              this.ToggleReportModal()
            this.setState({id:row.id})
            console.log(this.state.id)
            }}
            >
            Update Status
            </Button>

            // <Button
            //   type="button"
            //   color="primary"
            //   className="btn-sm btn-rounded"
            //   onClick={this}
            // >
            //   View Details
            // </Button>
          ),
        },
      ],
    };
    this.toggle = this.toggle.bind(this);
    this.toLowerCase1 = this.toLowerCase1.bind(this);
    this.ToggleReportModal = this.ToggleReportModal.bind(this);
  }

  toLowerCase1(str) {
    return str.toLowerCase();
  }

  componentDidMount() {
    const { orders, onGetOrders } = this.props;
    if (orders && !orders.length) {
      onGetOrders();
    }
    this.setState({ orders });
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { orders } = this.props;
    if (!isEmpty(orders) && size(prevProps.orders) !== size(orders)) {
      this.setState({ orders: {}, isEdit: false });
    }
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  ToggleReportModal() {
    this.setState(prevState => ({
      reportmodal: !prevState.reportmodal,
      
    }));
    console.log("Toggle On");
  }

  toggleViewModal = () => {
    this.setState(prevState => ({
      viewmodal: !prevState.viewmodal,
    }));
  };
  render() {
    const { orders } = this.props;

    //pagination customization
    const pageOptions = {
      sizePerPage: 5,
      totalSize: orders.length, // replace later with size(Order),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "orderId",
        order: "desc",
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.reportmodal}
          toggle={this.ToggleReportModal}
          size="lg"
          scrollable={true} // to enable scrollable body
          centered={true} //to center the modal vertically
          backdrop={"static"} //to disable click outside the modal
        >
          <div className="modal-header align-center">
            <h5 className="modal-title mt-3 ">Update Status</h5>
            {/*  */}
            <button
              type="button"
              onClick={() => this.setState({ reportmodal: false })}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            
              <Col lg="12">
                <div className="mb-3 w-50 h-75">
                  <Label for="basicpill-address-input1">Enter Status</Label>
                  <textarea
                    id="basicpill-address-input1"
                    className="form-control"
                    rows="2"
                    placeholder="Enter Details of Complaint"
                    onChange={e => {
                      this.setState({
                        Description: e.target.value,
                      });
                    }}
                  />
                </div>
                <div
                  style={{
                    // width: "38%",
                    display: "flex",
                    // justifyContent: "space-between",
                  }}
                >
                  <button
                    type="submit"
                    className="btn"
                    style={{
                      backgroundColor: "#0154E0",
                      color: "white",
                    }}
                    onClick={async () => {                                          
                        const myPromise = axios.put(
                          `${url}/Appointments/respondpayable/${this.state.id}`,
                          {
                            
                            Status: this.state.Description,
                           

                          },
                          
                        );
                        try {
                          toast.promise(myPromise, {
                            loading: "Updating status.."

                            ,
                            
                            success:
                              "Payment status updated successfully",
                              
                            error:"Error updating status",
                          });
                          this.setState({ reportmodal: false })
                          console.log(this.state.serivceid)
                        
                          const response = await myPromise;
                          return response.data;
                          
                        } catch (error) {
                          console.log("error = " + error.message);
                          toast(error.message)
                          throw error;                   
                      }
                     
                    }}
                  >
                    Update Status
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mx-3 pl-2"
                    onClick={() => this.setState({ reportmodal: false })}
                  >
                    Cancel
                  </button>
                </div>
              </Col>
           
          </div>
        </Modal>
        <EcommerceOrdersModal
          isOpen={this.state.viewmodal}
          toggle={this.toggleViewModal}
        />
        <Card>
          <CardBody>
            <div className="mb-4 h4 card-title">Payable Amounts</div>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={this.state.EcommerceOrderColumns}
              data={orders}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={orders}
                  columns={this.state.EcommerceOrderColumns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div className="table-responsive">
                        <BootstrapTable
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                          responsive
                          defaultSorted={defaultSorted}
                          bordered={false}
                          striped={false}
                          selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap table-check"
                          }
                          headerWrapperClasses={"table-light"}
                        />
                      </div>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

LatestTranaction.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onAddNewOrder: PropTypes.func,
  onDeleteOrder: PropTypes.func,
  onUpdateOrder: PropTypes.func,
};

const mapStateToProps = state => ({
  orders: state.ecommerce.orders,
});

const mapDispatchToProps = dispatch => ({
  onGetOrders: () => dispatch(getOrders()),
  onAddNewOrder: order => dispatch(addNewOrder(order)),
  onUpdateOrder: order => dispatch(updateOrder(order)),
  onDeleteOrder: order => dispatch(deleteOrder(order)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LatestTranaction));
